
interface Props {
    filters: any,
    path: string
    token?: string
}


export const getSeverData = async <T>({ filters, path }: Props): Promise<T | null> => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const url = process.env.BACKEND_URL + path
        const data = await fetch(url, { method: "POST", headers: myHeaders, body: JSON.stringify(filters), cache: "no-cache" })

        if (!data.ok) {
            console.error(`API Error: ${data.status} ${data.statusText} from ${url}`)
            return null
        }

        const res = await data.json()
        return res?.data
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        console.log(error)
        return null
    }
}

export const submitData = async <T>({ options, url, token }: { options: RequestInit, url: string, token: string }): Promise<T | any> => {
    try {
        const myHeaders = new Headers(options?.headers);
        if (!myHeaders.has("Content-Type")) {
            myHeaders.append("Content-Type", "application/json");
        }
        if (token) myHeaders.append("Authorization", `Bearer ${token}`);
        const requestOptions: any = {
            ...options, headers: myHeaders
        }
        const response = await fetch(url, requestOptions);
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        return json
    } catch (error) {
        console.log(error)
        return null
    }
}


export const submitMultipartData = async <T>({ options, url, token }: { options: RequestInit, url: string, token: string }): Promise<T | any> => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        const requestOptions: any = {
            ...options, headers: myHeaders
        }
        const response = await fetch(url, requestOptions);
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        return json
    } catch (error) {
        return null
    }
}



export const getData = async <T>({ options, url, token }: { options: RequestInit, url: string, token: string }): Promise<T | any> => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);
        const requestOptions: any = {
            ...options, headers: myHeaders
        }
        const response = await fetch(url, requestOptions);
        if (!response.ok) throw new Error(response.statusText);
        const json = await response.json();
        const { data } = json
        return data
    } catch (error) {
        return null
    }
}


export const getAuthSeverData = async <T>({ token, filters, path }: Props): Promise<T | null> => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);
        const url = process.env.BACKEND_URL + path
        const data = await fetch(url, { method: "POST", headers: myHeaders, body: JSON.stringify(filters), cache: "no-cache" })
        const res = await data.json()
        // console.log(res)
        return res?.data
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        console.log(error)
        return null
    }
}


export const getStaticData = async <T>({ filters, path }: Props): Promise<T | null> => {
    try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const url = process.env.BACKEND_URL + path
        const data = await fetch(url, { method: "POST", headers: myHeaders, body: JSON.stringify(filters)})

        if (!data.ok) {
            console.error(`API Error: ${data.status} ${data.statusText} from ${url}`)
            return null
        }

        const res = await data.json()
        return res?.data
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        console.log(error)
        return null
    }
}